import * as React from "react";

const SvgComponent = ({ width = "20px", height = "20px", color = "#333333", ...props }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.668 0a10 10 0 1 0 10 10 10.012 10.012 0 0 0-10-10Zm0 18.461A8.462 8.462 0 1 1 19.13 10a8.47 8.47 0 0 1-8.462 8.461Z"
      fill={color}
    />
    <path
      d="M11.822 14.23a1.154 1.154 0 1 1-2.308 0 1.154 1.154 0 0 1 2.308 0ZM11.22 4.663A3.077 3.077 0 0 0 7.59 7.692a.77.77 0 1 0 1.539 0 1.539 1.539 0 0 1 2.627-1.086 1.539 1.539 0 0 1-.496 2.512A2.244 2.244 0 0 0 9.9 11.214v.324a.77.77 0 1 0 1.538 0v-.324a.724.724 0 0 1 .406-.679 3.071 3.071 0 0 0 .998-5.017 3.106 3.106 0 0 0-1.621-.855Z"
      fill={color}
    />
  </svg>
);

export default SvgComponent;